import { Button, ErrorLayout } from "@digitalreality/ui";
import React from "react";
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <ErrorLayout title="Something went wrong" text="Please try again later">
      <Link to="dashboard">
        <Button>Back to home</Button>{" "}
      </Link>
    </ErrorLayout>
  );
}
